__webpack_require__.p = "/prompt-monster/";